var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXtwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 35,
    viewBox: "0 0 38 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0926478 0L14.764 19.3046L0 35H3.32279L16.2487 21.2584L26.6924 35H38L22.5031 14.6096L36.2454 0H32.9226L21.0185 12.6557L11.4002 0H0.0926478ZM4.97906 2.40859H10.1738L33.1128 32.591H27.9181L4.97906 2.40859Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXtwitter);
export default __webpack_public_path__ + "static/media/xtwitter.3d5fb13a1878f218661f2c5f9a563dde.svg";
export { ForwardRef as ReactComponent };